import { IconProps } from "./types"

export default (props: IconProps): JSX.Element => {
    const { width = 16, height = 16, fillPath = 'var(--color-gray-neutral)' } = props;
    return (

        <svg
            width={width}
            height={height}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.854 2.146a.5.5 0 0 1 0 .708l-11 11a.5.5 0 1 1-.708-.708l11-11a.5.5 0 0 1 .707 0z"
                fill={fillPath} />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.854 13.854a.5.5 0 0 1-.707 0l-11-11a.5.5 0 1 1 .707-.708l11 11a.5.5 0 0 1 0 .707z"
                fill={fillPath} />
        </svg>
    )
}